import { ImportProcessingStrategy as P } from '@today/types'

/**
 * What each strategy does with current records the file does not contain
 * (TO-400 BR-10). The policy is the strategy — the F9 planner applies it;
 * there is no separate field to set.
 */
export const MISSING_RECORD_POLICY: Readonly<Record<P, string>> = Object.freeze({
	[P.FULL_LOAD]: 'Records missing from the file are deactivated.',
	[P.REPLACE]: "All current records are deactivated and the file's records are created.",
	[P.UPSERT]: 'Records missing from the file are kept.',
	[P.APPEND]: 'Every record is created; nothing is matched or deactivated.',
})

export const STRATEGY_LABELS: Readonly<Record<P, string>> = Object.freeze({
	[P.FULL_LOAD]: 'Full load',
	[P.REPLACE]: 'Replace',
	[P.UPSERT]: 'Upsert',
	[P.APPEND]: 'Append',
})
